module.exports = __webpack_public_path__ + "media/video_poster/desktop-22a7d2b8.png";